import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useOwnerSession } from "@/hooks/useOwnerSession";
import { useEmployeeSession } from "@/hooks/useEmployeeSession";
import { isRegularOwnerSession } from "@/lib/ownerSessionRouting";

/**
 * ROOT CUTOVER K1 (Juli 2026) – Standard-Einstiegsroute "/".
 *
 * Betreiberentscheidung Ziel A: Die statische Landingpage
 * (public/landing/index.html) ist der EINZIGE Root-Einstieg. Die alte
 * React-Landingpage (LandingPage.jsx, Phase "search") besitzt keinen
 * aktiven Renderpfad mehr und darf hier nie wieder eingebunden werden.
 *
 * Anonyme Besucher, die per SPA-/History-Navigation (popstate, Catch-all
 * "*" → "/") auf "/" landen, werden per VOLLER Dokument-Navigation zur
 * statischen Landingpage geführt; deren Runtime setzt die URL via
 * history.replaceState zurück auf "/". Kein Schleifenrisiko: das Ziel
 * ist eine statische Datei (Preview: express.static, Produktion:
 * Build-Artefakt), die nie wieder React lädt.
 *
 * - Owner eingeloggt (regulär) → /unternehmer (ProtectedOwnerRoute validiert das Token)
 * - Mitarbeiter eingeloggt     → /monteur     (ProtectedMonteurRoute validiert das Token)
 * - sonst (inkl. public-preview) → volle Navigation zur statischen Landingpage
 *
 * V2I (Juli 2026): `public-preview`-Sessions (anonyme LP3-Vorschau) zählen für
 * die automatische Navigation NICHT als Owner (isRegularOwnerSession) — sie
 * behalten aber ihre owner_session unangetastet (kein Cleanup, kein Logout).
 */
export default function RootRoute() {
  const { session: owner } = useOwnerSession();
  const { session: employee } = useEmployeeSession();
  const regularOwner = isRegularOwnerSession(owner);
  // AUTH-SICHERHEIT V2 · Phase 2: Employee-Session hat kein token-Feld mehr;
  // Marker ist die vorhandene Mitarbeiter-Kennung.
  const employeeLoggedIn = Boolean(employee?.employee?.id);
  const loggedIn = Boolean(regularOwner || employeeLoggedIn);

  useEffect(() => {
    if (!loggedIn) {
      window.location.replace("/landing/index.html" + window.location.search + window.location.hash);
    }
  }, [loggedIn]);

  if (regularOwner) return <Navigate to="/unternehmer" replace />;
  if (employeeLoggedIn) return <Navigate to="/monteur" replace />;
  return null;
}
